import { ApiEndPoints, NetworkManager } from "../network";

export class RolesService {
  static getAllRoles = (page = 1, limit = 10, pages = 1) => {
    return NetworkManager.getInstance().appRequest({
      method: "get",
      url: ApiEndPoints.getRoles,
      params: { page, pages, limit },
    });
  };
}
